import type { GetRichMenuTemplatesResponse, UpdateRichmenuTabGroupRequest } from "@di-devs/richmenu-feature-plugin/shared";
import { useMutation, useQuery } from "@tanstack/react-query";
import type { FeatureClient } from "@/config/client";
import { queries } from "./index";

export const useRichMenuTemplatesQuery = (client: FeatureClient) => {
	return useQuery({
		queryKey: queries.richmenus.templates.queryKey,
		queryFn: async (args) => {
			const templates: { data: GetRichMenuTemplatesResponse, error: null } =
				await client.getRichMenuTemplates(args);
			return templates;
		},
	});
};

export const useRichMenuTabGroupsQuery = (client: FeatureClient) => {
	return useQuery({
		queryKey: queries.richmenus.tabGroups.queryKey,
		queryFn: client.getRichMenuTabGroups,
	});
};

export const useCreateRichMenuTabGroupMutation = (client: FeatureClient) => {
	return useMutation({
		mutationKey: queries.richmenus.tabGroups.queryKey,
		mutationFn: client.createRichMenuTabGroup,
	});
};

export const useUpdateRichMenuTabGroupMutation = (client: FeatureClient) => {
	return useMutation({
		mutationKey: queries.richmenus.tabGroups.queryKey,
		mutationFn: (data: {
			body: UpdateRichmenuTabGroupRequest;
			params: { tabGroupId: number | undefined };
		}) =>
			client.updateRichmenuTabGroup(Number(data.params?.tabGroupId), data.body),
	});
};

// export const useUploadRichMenuImageMutation = () => {
// 	return useMutation({
// 		mutationKey: queries.richmenus.tabGroups.queryKey,
// 		mutationFn: (data: {
// 			body: {
// 				richmenuImage: File;
// 			},
// 			params: { id: number }
// 		}) => reactFeatureClient.setRichMenuImage(data.params.id, data.body)
// 	})
// }

export const useDeleteRichMenuTabGroupMutation = (client: FeatureClient) => {
	return useMutation({
		mutationKey: queries.richmenus.tabGroups.queryKey,
		mutationFn: client.deleteRichMenuTabGroup,
	});
};

export const usePublishRichMenuTabGroupMutation = (client: FeatureClient) => {
	return useMutation({
		mutationKey: queries.richmenus.tabGroups.queryKey,
		mutationFn: client.publishRichmenuTabGroup,
	});
};

export const useUnpublishRichMenuTabGroupMutation = (client: FeatureClient) => {
	return useMutation({
		mutationKey: queries.richmenus.tabGroups.queryKey,
		mutationFn: client.unpublishRichmenuTabGroup,
	});
};
